import React from 'react';
import './Shelf.css';

const Shelf = ({ title, children }) => {
    return (
        <div className="library-shelf">
            <h2 className="shelf-title">
                <span className="title-marker"></span>
                {title}
            </h2>
            <div className="shelf-grid">
                {children}
            </div>
            <div className="shelf-base"></div>
        </div>
    );
};

export default Shelf;
